import React from 'react'
import { withRouter } from 'react-router-dom'
import BulletScreen from 'rc-bullets'
import { Container, Header, Wrapper } from '../../components_renew/Layout'
import api from '../../api'
import { postMessage } from '../../utils'
import imgHeader from '../../assets/xiniu/new_user_event/header.png'
import imgAvatar from '../../assets/img/user_avatar.png'
import imgFire from '../../assets/img/icon_fire.png'

@withRouter
class NewUserEvent extends React.PureComponent {
  state = {
    screen: undefined
  }

  interval

  componentDidMount () {
    this.fetchData()
  }

  componentWillUnmount () {
    clearInterval(this.interval)
  }

  fetchData = () => {
    api.danmu.fetchDanmuData()
      .then(res => {
        const s = new BulletScreen('#screen', {
          duration: 10,
          pauseOnHover: false,
          // loopCount: 'infinite'
        })
        this.setState({ screen: s })
        const pushItem = () => {
          function getRandomItem () {
            let random = parseInt(String(Math.random() * 30), 10)
            if (res[random]) {
              return <div className={'danmu-item__container'}>
                <img className={'danmu-item__head'} src={imgAvatar} alt=''/>
                <div className={'danmu-item__content'} dangerouslySetInnerHTML={{ __html: res[random] }}/>
              </div>
            } else {
              return getRandomItem()
            }
          }

          this.state.screen &&
          this.state.screen.push(getRandomItem())
        }
        pushItem()
        setTimeout(pushItem, 400)
        setTimeout(pushItem, 800)
        setTimeout(pushItem, 1200)
        this.interval = setInterval(pushItem, 1800)
        // res.forEach(item => s.push(<div dangerouslySetInnerHTML={{__html: item}}></div>))
      })
  }

  render () {
    const { withHeader } = this.props
    return <Container>
      {withHeader ? <Header>活动</Header> : null}
      <Wrapper className={'l-lg_bg--light'} style={{zIndex: 0}}>
        <img style={
          {
            display: 'block',
            width: '100%',
            marginTop: '2rem'
          }
        }
             src={imgHeader} alt=''/>
        <div className={'mx-4'}>
          <div className={'e-new-user__card'}>
            <img src={imgFire} alt=''/>
            &nbsp;
            <div>每天10000+用户提现</div>
          </div>
          <div style={{
            zIndex: 1,
            padding: '1rem 0',
            background: 'white',
            marginBottom: '1rem',
            borderRadius: 8,
          }}>
            <div id={'screen'} style={{
              height: 200,
              overflow: 'hidden',
            }}/>
          </div>
        </div>
        {/*<WingBlank>*/}
        {/*  <Button type={'primary'} onClick={this.onClick}>新用户注册0元赚钱</Button>*/}
        {/*</WingBlank>*/}
      </Wrapper>
    </Container>
  }

  onClick = () => {
    postMessage({ type: window.POST_TYPE.REGISTER })
    // postMessage({ type: 'register' })
  }
}

export default NewUserEvent
